/**
 * One vote's state and result (work hub, 2026-10-31): the status, who votes (the board or the members), the outcome and
 * the counts per option once closed. One component for Avstemninger (the result under a vote) and Styremøter (the vote
 * on an agenda item, inline). Never anyone's choice — the list of who voted what stays on Avstemninger's own page.
 */
import React from 'react';
import type { Body } from '../lib/api';
import { osloTime } from '../lib/format';
import { Btn, Tag, type TagTone } from './ui';
import { Voting } from '../core';

export const STATUS_TONE: Record<string, TagTone> = { draft: 'grey', open: 'green', closed: 'gold', cancelled: 'red' };
export const OUTCOME_TONE: Record<string, TagTone> = { adopted: 'green', rejected: 'red', no_quorum: 'grey' };

export function VoteCard({ vote, compact = false, onOpen }: { vote: Body; compact?: boolean; onOpen?: () => void }) {
  const res = vote.result;
  return (
    <div className="vote-card">
      <p style={{ margin: '4px 0' }}>
        {compact && <b>{vote.title} </b>}
        <Tag tone={STATUS_TONE[vote.status] || 'grey'}>{Voting.STATUS_NO[vote.status] || vote.status}</Tag>{' '}
        {vote.scope === 'members' && <><Tag tone="gold">{Voting.SCOPE_NO.members}</Tag>{' '}</>}
        {res && <><Tag tone={OUTCOME_TONE[res.outcome] || 'grey'}>{Voting.OUTCOME_NO[res.outcome]}</Tag>{' '}</>}
        {vote.status === 'open' && vote.closesAt && <span className="note">Stenger {osloTime(vote.closesAt)}. </span>}
        {compact && res && <span className="note">{Voting.countsText(vote.options || [], res.counts || [])}</span>}
        {onOpen && <> <Btn ghost onClick={onOpen} aria-label={`Åpne avstemningen ${vote.title}`}>Åpne</Btn></>}
      </p>
      {!compact && res && (
        <>
          <p>{res.cast} av {res.eligible} stemte{res.quorumCount ? ` (minst ${res.quorumCount} måtte stemme)` : ''}.
            {res.winner !== null && res.winner !== 0 && <> «{vote.options[res.winner]}» fikk flertall.</>}</p>
          <table className="t">
            <thead><tr><th scope="col">Alternativ</th><th scope="col">Stemmer</th></tr></thead>
            <tbody>{(vote.options || []).map((o: string, i: number) => <tr key={i}><td>{o}</td><td>{res.counts[i]}</td></tr>)}</tbody>
          </table>
        </>
      )}
    </div>
  );
}
